module.exports = __webpack_public_path__ + "media/images/underline2-cec680eb603a2aa88e18ba5c242686c9.svg";